export type Environment = 'local' | 'test' | 'prod';

interface EnvironmentConfig {
  version: string;
  apiBaseUrl: string;
  s3BucketName: string;
  s3BucketDomain: string;
  cloudFrontDomain: string;
  appDomain: string;
  polarBaseUrl: string;
  /** Polar 결제 포털(회사) URL - polarBaseUrl + 'company' */
  paymentProcessorUrl: string;
}

const configs: Record<Environment, EnvironmentConfig> = {
  local: {
    version: process.env.REACT_APP_VERSION_LOCAL || '',
    apiBaseUrl: process.env.REACT_APP_BACKEND_IP_LOCAL || '',
    s3BucketName: process.env.REACT_APP_S3_BUCKET_NAME_LOCAL || '',
    s3BucketDomain: process.env.REACT_APP_BUCKET_DOMAIN_LOCAL || '',
    cloudFrontDomain: process.env.REACT_APP_DOMAIN_LOCAL || '',
    appDomain: process.env.REACT_APP_DOMAIN_LOCAL || '',
    polarBaseUrl: process.env.REACT_APP_POLAR_DOMAIN_TEST || '',
    paymentProcessorUrl: (process.env.REACT_APP_POLAR_DOMAIN_TEST || '') + 'company',
  },
  test: {
    version: process.env.REACT_APP_VERSION_TEST || '',
    apiBaseUrl: process.env.REACT_APP_BACKEND_IP_TEST || '',
    s3BucketName: process.env.REACT_APP_S3_BUCKET_NAME_TEST || '',
    s3BucketDomain: process.env.REACT_APP_BUCKET_DOMAIN_TEST || '',
    cloudFrontDomain: process.env.REACT_APP_DOMAIN_TEST || '',
    appDomain: process.env.REACT_APP_DOMAIN_TEST || '',
    polarBaseUrl: process.env.REACT_APP_POLAR_DOMAIN_TEST || '',
    paymentProcessorUrl: (process.env.REACT_APP_POLAR_DOMAIN_TEST || '') + 'company',
  },
  prod: {
    version: process.env.REACT_APP_VERSION_PROD || '',
    apiBaseUrl: process.env.REACT_APP_BACKEND_IP_PROD || '',
    s3BucketName: process.env.REACT_APP_S3_BUCKET_NAME_PROD || '',
    s3BucketDomain: process.env.REACT_APP_BUCKET_DOMAIN_PROD || '',
    cloudFrontDomain: process.env.REACT_APP_DOMAIN_PROD || '',
    appDomain: process.env.REACT_APP_DOMAIN_PROD || '',
    polarBaseUrl: process.env.REACT_APP_POLAR_DOMAIN_PROD || '',
    paymentProcessorUrl: (process.env.REACT_APP_POLAR_DOMAIN_PROD || '') + 'company',
  },
};

const getEnvironment = (): Environment => {
  const env = process.env.REACT_APP_ENV as Environment;
  if (env !== 'local' && env !== 'test' && env !== 'prod') {
    throw new Error(`Invalid environment: ${env}. Must be either 'local' or 'test' or 'prod'.`);
  }
  return env;
};

export const getConfig = (): EnvironmentConfig => {
  const env = getEnvironment();
  const config = configs[env];

  if (env === 'prod' && !config.apiBaseUrl) {
    throw new Error('REACT_APP_BACKEND_PROD_IP is not set for production environment');
  }

  return config;
};